import classNames from "classnames";
import {
  EXPLORE_SORT,
  EXPLORE_SORT_QUERY,
} from "enums/new-explore/explore-sort";
import { useRouter } from "next/router";
import { FC } from "react";
import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import { EXPLORE_SLUG } from "types/api/explore";
import { exploreTitle } from "constants/new-explore/valid-filters";
import { sortItem } from "../helpers/constants";
interface Props {
  count?: number;
  handleClickOnSort?: (name: EXPLORE_SORT) => void;
}
const ProductTab: FC<Props> = ({ count, handleClickOnSort }) => {
  const router = useRouter();
  const { query } = router;
  const isActiveSort = (query.sort as EXPLORE_SORT) || EXPLORE_SORT.MOST_SOLD;

  return (
    <div
      className={classNames(
        "flex w-full -mx-4     px-4     fds-l:-mx-6  fds-l:px-6   items-center border-b border-b-fds-default mt-1 mb-4     fds-l:mb-8   fds-l:mt-2.5   box-content",
        sortItem?.length ? "justify-between " : "justify-end"
      )}
    >
      {sortItem.length ? (
        <div className="flex justify-between  items-center">
          <div className="flex gap-x-4 items-stretch pt-2  ">
            {sortItem.map(({ query, persian_name, name }) => (
              <div
                key={query}
                className={classNames(
                  "p-3 items-stretch box-content  relative hover:bg-fds-secondary cursor-pointer",
                  {
                    "after:content-[''] hover:!bg-fds-brand-light after:h-0.5 after:bg-fds-brand after:w-full after:right-0 after:rounded-t-2 after:absolute after:-bottom-px ":
                      isActiveSort === name,
                  }
                )}
                onClick={() => handleClickOnSort?.(name)}
              >
                <p
                  className={classNames(
                    "fds-l:title-md-medium title-sm",
                    isActiveSort === name
                      ? "text-fds-brand"
                      : "text-fds-secondary"
                  )}
                >
                  {persian_name}
                </p>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      {count ? (
        <p className=" text-fds-tertiary body-md self-end py-2.5 hidden fds-l:block">
          {separateMoneyNumbers(toFarsiNumber(count))}{" "}
          {exploreTitle[String(query.slug) as EXPLORE_SLUG] || "عنوان آموزشی"}
        </p>
      ) : null}
    </div>
  );
};

export default ProductTab;
